import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { ReconcilliationReportRoutingModule } from './reconcilliationReport.routing.module';
import { ReconcilliationReportComponent } from './reconcilliation-report.component';
import { NgxPaginationModule } from 'ngx-pagination';

@NgModule({
  declarations: [ReconcilliationReportComponent],
  imports: [
    CommonModule,
    ReconcilliationReportRoutingModule,
    FormsModule, NgxPaginationModule
   
  ]
})
export class ReconcilliationReportModule { }
